<div class="app-admin-wrap" [dir]="layoutConf?.dir">
  <!-- Header for top navigation layout -->
  <!-- ONLY REQUIRED FOR **TOP** NAVIGATION LAYOUT -->
  @if (layoutConf.navigationPos === 'top') {
    <app-header-top
      [notificPanel]="notificationPanel"
      >
    </app-header-top>
  }
  <!-- Main Container -->
  <mat-sidenav-container [dir]="layoutConf.dir">
    <mat-sidenav-content>
      <!-- SIDEBAR -->
      <!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->

      <!-- Top navigation layout (navigation for mobile screen) -->
      <!-- ONLY REQUIRED FOR **TOP** NAVIGATION MOBILE LAYOUT -->

      <!-- App content -->
      <main
        class="main-content-wrap"
        id="main-content-wrap"
        [attr.aria-busy]="isModuleLoading"
        >
        <!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
        @if (layoutConf.navigationPos === 'side') {
          <app-student-header>
          </app-student-header>
        }

        <div
          class="rightside-content-hold"
          id="rightside-content-hold"
          >
          <!-- View Loader -->
          @if (isModuleLoading) {
            <div
              class="view-loader flex-column-center"
              role="status"
              aria-live="polite"
              aria-label="Loading page"
              style="position: fixed;"
              >
              <span class="qtac-visually-hidden">Loading page</span>
              <div class="spinner">
                <div class="double-bounce1 mat-bg-accent"></div>
                <div class="double-bounce2 mat-bg-primary"></div>
              </div>
            </div>
          }

          <!-- View outlet -->
          <router-outlet></router-outlet>
          @if (!layoutConf.footerFixed) {
            <span class="layout-spacer"></span>
          }
          @if (!layoutConf.footerFixed) {
            <app-footer
              style="display: block; margin: 0 -0.25rem -0.25rem;"
            ></app-footer>
          }
        </div>
        @if (layoutConf.footerFixed) {
          <span class="layout-spacer"></span>
        }
        @if (layoutConf.footerFixed) {
          <app-footer></app-footer>
        }
      </main>
      <!-- View overlay for mobile navigation -->
      <button
        type="button"
        class="sidebar-backdrop"
        aria-label="Close navigation"
        [ngClass]="{'visible': layoutConf.sidebarStyle !== 'closed' && layoutConf.isMobile}"
        (click)="closeSidebar()"
      ></button>
    </mat-sidenav-content>

    <!-- Notificaation bar -->
    <mat-sidenav #notificationPanel mode="over" class="" position="end">
      <div class="nofication-panel flex-column">
        <app-notifications
          [notificPanel]="notificationPanel"
        ></app-notifications>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
